import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error import not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SystemMessage from '../system-message/SystemMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { CallingIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallStatusSystemMessage = ({
  message,
  ungatedForThreadMessagesUIImprovements
}) => {
  const timestamp = getTimestamp(message);
  return /*#__PURE__*/_jsx(SystemMessage, {
    "data-test-id": "inbound-call-received-message",
    timestamp: timestamp,
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.threadCallStatus.inboundCallReceived'
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: CallingIcon,
      size: "500"
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
CallStatusSystemMessage.displayName = 'CallStatusSystemMessage';
export default CallStatusSystemMessage;